import service from '../services/apiSuscripciones';


const Countdown = () => {

    if (document.querySelector('.countdown')) {

        const countdown = document.querySelector('.countdown'),
            countdownCloseBtn = document.querySelector('.countdown__close'),
            countdownSuscriptions = document.querySelector('.countdown__suscriptions');

        const fadeOutUp = element => {
            element.classList.remove('fadeInUp');
            element.classList.add('fadeOutUp');
        };

        const getStock = () => {
            return service.get('/stock')
                .then(data => {
                    console.log('stock', data);
                    if (data) {
                        countdownSuscriptions.innerHTML = data;
                        return Promise.resolve(true);
                    }
                    else {
                        countdown.remove();
                        console.log(`no hay promo de stock configurada`)
                        return Promise.resolve(false);
                    }

                });
        }

        const stockHandler = (result) => {
            if (result) {
                setTimeout(() => {
                    getStock()
                        .then(stockHandler)
                        .catch(() => {
                            countdown.remove();
                            console.log('ocurrio un error al obtener stock');
                        })
                }
                    , 10 * 1000 * 60);
            }
        }

        countdownCloseBtn.addEventListener('click', () => fadeOutUp(countdown));
        setTimeout(() => countdown.style.animationDelay = 0, 700);
        getStock()
            .then(stockHandler);
    }
};

module.exports = {
    init: () => {
        Countdown();
    }
};



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/components/countdown.js